﻿import { IRccapSecondaryCause } from './rccap-secondary-cause';

export interface IRccapRootCause {
    id: number;
    description: string;
    secondaryCauses: IRccapSecondaryCause[];
}
